import { FC, SVGAttributes } from "react";

const SizeIcon: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0H32V32H0z"
        transform="translate(-16 -348) translate(16 348)"
      />
      <g transform="translate(-16 -348) translate(16 348) translate(3 10)">
        <path stroke="#000" strokeWidth="2" d="M25 1v10H1V1h24z" />
        <rect width="2" height="2" x="19" y="5" fill="#000" rx="1" />
        <path
          stroke="#000"
          strokeWidth="1.5"
          d="M4 1L4 4M7 1L7 6M10 1L10 4M16 1L16 4M13 1L13 6"
        />
      </g>
    </g>
  </svg>
);

export { SizeIcon };
